"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.codeLogin = codeLogin;
exports.getDeviceType = getDeviceType;
exports.getInfo = getInfo;
exports.getPlatformConfig = getPlatformConfig;
exports.login = login;
exports.postSetRecode = postSetRecode;
var _request = require("@/utils/request");
function login(data) {
  return (0, _request.$post)('/agentapi/login', data);
}
function codeLogin(data) {
  return (0, _request.$post)('/commonapi/register/check_captche', data);
}
function getInfo(token) {
  return (0, _request.$get)('/agentapi/my_user_info', {
    token: token
  });
}
function getPlatformConfig() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.$get)('/commonapi/get_platform_config', params);
}
function getDeviceType() {
  return (0, _request.$get)('/agentapi/ucenter/my_device_type');
}
function postSetRecode(data) {
  return (0, _request.$post)('/agentapi/log/add_record', data);
}